import React, { useEffect, useState, useCallback } from "react";
import API from "../Services/TaxRate";

const TaxRateListList = ({ selectedTaxRate, setSelectedTaxRate, taxRates }) => {

    const [taxRate, settaxRate] = useState([]);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        setSelectedTaxRate(e.target.value);
    };


    const bindTaxRate = useCallback(async () => {
        try {
            const response = await API.getTaxRate({
                is_active: 1,
            });
            // console.log("tx rte...", response)
            settaxRate(response?.data?.data.rows);
            // console.log(response?.data?.data);
        } catch (error) {
            setError("Failed to fetch tax rate.");
            console.error(error);
            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
        }
    }, []);

    useEffect(() => {
        bindTaxRate();
    }, [bindTaxRate]);

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="form-group">
                    <label htmlFor="Designation">Tax Rate <span style={{ color: "red" }}>*</span></label>
                    <select className="form-select" id="ddlDesignation" value={selectedTaxRate}
                        onChange={handleChange}>
                        <option value="">Select</option>
                        {taxRate.length > 0 ? (
                            taxRate.map((taxRate) => (
                                <option key={taxRate.id} value={taxRate.id}>
                                    {taxRate.type}
                                </option>
                            ))
                        ) : (
                            <option disabled>No Tax Rate available</option>
                        )}
                    </select>
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                </div>
            </div>
        </div>
    );
};

export default TaxRateListList;
